/**
 * @returns {boolean} check sessionStorage for debug flag
 */
export function isDebug(): boolean {
    let debug = false
    try {
        debug = JSON.parse(sessionStorage.debug as string) as boolean
    } catch {
        debug = false
    }
    return debug
}
